import { getHighestCountOfVenue } from 'lib/api/context';
import { IIncompleteOrder, IStreetData } from 'lib/types/api';

type QuantityParams = {
    /* The current quantity selected */
    currentQuantity: number;
    /* The (want to) updated quantity selected */
    updatedQuantity: number;
    /* If the field is dirty */
    isDirty: boolean;
    /* The highest count params */
    /* If it's a student or a teacher */
    isStudent: boolean;
    /* The order context */
    orderContext: IIncompleteOrder;
    /* The street data */
    street: IStreetData | null;
    /* Group Guid used to set the dirty fields */
    groupGuid: string;
    /* The dirty fields state */
    dirtyFields: string[];
    /* A callback called after a successful "max" quantity update has been done */
    callback: (fields: string[]) => void;
};

/**
 * Allows easy updating of the quantity field to the highest count of the venue.
 * Whenever the field is not dirty, and the updated quantity is higher than the current quantity,
 * it will return the updated quantity to the highest count of the venue.
 */
export const handleQuantityChange = ({
    currentQuantity,
    updatedQuantity,
    isDirty,
    isStudent,
    orderContext,
    street,
    groupGuid,
    dirtyFields,
    callback,
}: QuantityParams): number => {
    if (!isDirty && updatedQuantity > currentQuantity && street) {
        const maxVenueQuantity =
            getHighestCountOfVenue({
                isStudent,
                orderContext,
                street,
            }) ?? 1;
        if (maxVenueQuantity > 1) {
            updatedQuantity = maxVenueQuantity;
        }
        callback([...dirtyFields, groupGuid]);
    }
    return updatedQuantity;
};
